// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Formik, Form, Field } from 'formik';

import {
  Grid, Button, FormControlLabel,
} from '@material-ui/core';

import { Checkbox } from '../Formik';

import { TextField } from 'formik-material-ui';
import {DatePicker} from '@material-ui/pickers';

import { termValidation } from '../../validation';
import type { Term } from '../../schemas';

type Props = {
  classes: Object,
  initialValues: Object,
  terms: Term[],
  canUpdate: Function,
  handleClose: Function,
  handleSubmit: Function,
  handleDelete: Function,
  fetchTerms: Function,
  onChange: Function,
  formik: Object,
};

const styles = theme => ({
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    height: theme.spacing(2.5),
    marginTop: theme.spacing(1) / 4,
    marginRight: theme.spacing(1) / 4,
    marginLeft: theme.spacing(1) / 4,
  },
  avatar: {
    height: theme.spacing(2.5),
    width: theme.spacing(2.5),
  },
  avitarIcon: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
  }
});

class AcademicTermForm extends Component<Props> {
  render() {
    const {initialValues} = this.props;

    return(
      <Formik
        initialValues={initialValues}
        validationSchema={termValidation}
        onSubmit={values => this.props.handleSubmit(values)}
      >
        {({
          handleReset,setFieldValue,handleBlur,touched,isSubmitting,isValid,values
        }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item md={3} sm={6} xs={12}>
                <Field
                  fullWidth
                  disabled
                  name="name"
                  label="Name"
                  component={TextField}
                />
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <Field
                  fullWidth
                  required
                  variant="inline"
                  disableToolbar
                  name="TermAttr.startDate"
                  label="Start Date"
                  format="MMMM DD, YYYY"
                  autoOk
                  value={values.TermAttr.startDate}
                  onChange={date => {
                    const value = date !== null ? date : initialValues.TermAttr.startDate;
                    setFieldValue('TermAttr.startDate', value);
                  }}
                  onBlur={handleBlur}
                  component={DatePicker}
                />
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <Field
                  fullWidth
                  required
                  variant="inline"
                  disableToolbar
                  name="TermAttr.endDate"
                  label="End Date"
                  format="MMMM DD, YYYY"
                  autoOk
                  value={values.TermAttr.endDate}
                  onChange={date => {
                    const value = date !== null ? date : initialValues.TermAttr.endDate;
                    setFieldValue('TermAttr.endDate', value);
                  }}
                  onBlur={handleBlur}
                  component={DatePicker}
                />
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <Field
                  fullWidth
                  disabled
                  name="TermAttr.numberOfWeeks"
                  label="# of Weeks"
                  component={TextField}
                />
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <Field
                  fullWidth
                  required
                  variant="inline"
                  disableToolbar
                  name="TermAttr.placementStartDate"
                  label="Placement Start"
                  format="MMMM DD, YYYY"
                  autoOk
                  value={values.TermAttr.placementStartDate}
                  onChange={date => {
                    const value = date !== null ? date : initialValues.TermAttr.placementStartDate;
                    setFieldValue('TermAttr.placementStartDate', value);
                  }}
                  onBlur={handleBlur}
                  component={DatePicker}
                />
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <Field
                  fullWidth
                  required
                  variant="inline"
                  disableToolbar
                  name="TermAttr.placementEndDate"
                  label="Placement End"
                  format="MMMM DD, YYYY"
                  autoOk
                  value={values.TermAttr.placementEndDate}
                  onChange={date => {
                    const value = date !== null ? date : initialValues.TermAttr.placementEndDate;
                    setFieldValue('TermAttr.placementEndDate', value);
                  }}
                  onBlur={handleBlur}
                  component={DatePicker}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <Field
                  fullWidth
                  required
                  variant="inline"
                  disableToolbar
                  name="TermAttr.approvalDeadline"
                  label="Approval Deadline"
                  format="MMMM DD, YYYY"
                  autoOk
                  value={values.TermAttr.approvalDeadline}
                  onChange={date => {
                    const value = date !== null ? date : initialValues.TermAttr.approvalDeadline;
                    setFieldValue('TermAttr.approvalDeadline', value);
                  }}
                  onBlur={handleBlur}
                  component={DatePicker}
                />
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <FormControlLabel
                  label="Is Active"
                  control={
                    <Field
                      checked={_.get(values, 'TermAttr.isActive', false)}
                      name="TermAttr.isActive"
                      component={Checkbox}
                    />
                  }
                />
              </Grid>
            </Grid>
            <div style={{ padding: '2em 0 1em' }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={!this.props.canUpdate || isSubmitting || !isValid}
              >
                Save
              </Button>
              &nbsp;
              <Button
                variant="contained"
                color="default"
                disabled={!_.some(touched)}
                onClick={handleReset}
              >
                Reset
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

export default (withStyles(styles, {
  withTheme: true, name: 'AcademicTermForm'
})(AcademicTermForm): any);
